import React, { useContext, useEffect, useState, useRef } from 'react';
import { AuthContext } from '../../context/auth-context';

// import { MdDeleteOutline } from "react-icons/md";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";

import './comment.css';
import { IoIosSend } from "react-icons/io";



const Comment = ({ postId }) => {
    const { user } = useContext(AuthContext);
    const auth = useContext(AuthContext);
    const dropRef = useRef(null);

    const [post, setPost]= useState(null)
    const [isLoaded, setIsLoaded] = useState(false)

    const [drop, setDrop] = useState(null)

    const [inputData, setInputData] = useState({
  
        content: '',
 
    });

    // FETCH POST BY ID
     useEffect(() => {
         const fetchPost = async () => {
           try {
             const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/posts/${postId}`);
             const responseData = await response.json();
             setPost(responseData.post); // Ensure it is array
             setIsLoaded(true);
            //  console.log('this is the post', responseData.post)
           } catch (err) {
             console.log(err.message)
             setIsLoaded(true); // Avoiding infinite loading
           }
         };
       
           fetchPost();
       }, [postId]);
  
   

    useEffect(() => {
        if (user) {
            setInputData((prevState) => ({
                ...prevState,
                userId: user.id
            }))
        }
    }, [user])
  
    const inputHandler = (e) => {
        const { id, value} = e.target;
        setInputData((prevState) => ({
            ...prevState,
            [id]: value
        }))
    }

    const handleDrop = (commentId) => {
      setDrop(drop === commentId ? null : commentId);
    }

  // SUBMIT COMMENT TO BACKEND
  const handleComment = async (e) => {
    e.preventDefault();

    if (!user) {
        console.log('User not authenticated');
        return
      }

    try {  
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/posts/${postId}/comment`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + auth.token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: user.id,
                content: inputData.content
            })
        });


        if (!response.ok) {
            throw new Error('Failed to comment')
        }
        const responseData = await response.json();
        // console.log('Comment data: ', responseData.comment);

        setPost((prevPost) => ({
            ...prevPost,
            comments: [...prevPost.comments, responseData.comment]
        }));

        setInputData({ content: ' '});

    } catch(err) {
        console.log(err.message)
    }
   }

   // DELETE COMMENT
   const deleteComment = async (postId, commentId) => {
    const confirmDelete = window.confirm("Are you sure to delete the post!. ");

    if(!confirmDelete) {
      return
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/posts/${postId}/comment/${commentId}`,{
         method: 'DELETE',
         headers: {
          'Authorization': 'Bearer ' + auth.token
        }
      });
 
      if(!response.ok){
        const errorData = await response.json();
        throw new Error('Could not delete the post for provided id. '|| errorData.message)
      }
       
      setPost(prevPost => ({
        ...prevPost,
        comments: prevPost.comments.filter(comment => comment._id !== commentId)
      }))
    } catch (err) {
      console.log(err.message)
    }
   }
  //  console.log('auth.user', auth.user)
 
  
  return (
    <main className='com-container'>
      {isLoaded && post ? (      
        <>
          <div className='com-controller' style={{padding: '5px'}}> 
            <div className='com-postCreator-image'>
              <img 
                src={`${process.env.REACT_APP_ASSET_URL}/${post.creator.image}`} 
                alt={post.creator.name} 
                style={{width: '50px', height:'50px', borderRadius: '50px'}}
              /> 
              <div style={{display:'flex', flexDirection: 'column',marginLeft: '10px'}}>
                <div style={{fontWeight: 'bold'}}>
                {post.creator.name}
              </div>            
              <div style={{}}>
               
                {new Date(post.createdAt).toLocaleString()}
              </div>
              </div>
              
            </div>
            
            
            <div className='com-post'>         
              <h2 style={{textAlign:'center'}}>{post.title}</h2>

              {post.video ? (
                  <video controls width='100%' style={{borderRadius: '10px'}}>
                    <source 
                      src={`${process.env.REACT_APP_ASSET_URL}/${post.video}`}
                      type={`video/${post.video.split('.').pop()}`}
                    />
                  </video>
                ) : post.image ? (
                  <div className='com-post-image-container'>
                    <img  src={`${process.env.REACT_APP_ASSET_URL}/${post.image}`} alt='post pic' />
                  </div>
                ) : null
              }            
              <div style={{margin: '10px'}}>
                 <p>{post.post}</p>
              </div>
             
            </div>
            <h3>Comments</h3>

            <div style={{padding: '5px' }}>

              {/* Display comments of the post */}
              {post.comments && post.comments.length > 0 ? ( 

                post.comments.map((c, i) => { 
                  return (
                  <div key={i} style={{borderBottom:'1px solid black', borderRadius:'4px', marginBottom: '8px', boxShadow: '0px 0px 2px 0px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', borderRadius: '5px 5px 0px 0px', backgroundColor: '#cccccc'}}>
                      <div style={{display:'flex'}}>
                        <div style={{alignItems:'center', marginRight: '8px'}}>
                          <img src={`${process.env.REACT_APP_ASSET_URL}/${c.id.image}`} alt={c.name} style={{width: '40px', height:'40px', borderRadius: '50px', margin: '2px'}}/>                    
                        </div>   

                        <div style={{display: 'flex', flexDirection:'column', alignItems:'start', justifyItems:'start'}} >   
                          <strong>{c.id.name}</strong>                 
                          <small>{new Date(c.createdAt).toLocaleString()}</small>                   
                        </div>   
                      </div>

                      {/* Delete button see only for comment creator */}
                      {auth.isLoggedIn && auth.user.id === c.id.id && (
                      <div ref={dropRef}  className='userPost-del-container'>
                        <div onClick={() => {handleDrop(c.id)}}  className='userPost-del-controller'>

                          <div className='userPost-del-dots'>
                            <button><PiDotsThreeOutlineVerticalFill fontSize={25} color='black'/></button>
                          </div>

                          <div className={`userPost-drop ${drop === c.id ? "show" : "hide"}`}>

                            <div className='userPost-drop-delete'>
                              <button onClick={() => deleteComment(post._id, c._id)}>Delete</button>
                            </div>
                            <div className='userPost-drop-edit'>
                              <button>Edit</button>
                            </div>

                          </div>
                        </div>             
                      </div> 
                         )}     
                    </div>
                    <div style={{margin: '10px'}}>
                    <p>{c.content}</p>  
                    </div>                                        
                  </div>
                );
              })
              ) : (
                <p>No comments yet. </p>
              )}
            </div>
          </div>

        {/* Type Comment */}
          {user ? (
            <form onSubmit={handleComment} className='com-form-container'>
              <label htmlFor='text'/>
              <div className='com-form-controller'> 
                <img src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} alt={user.name}/>    
                  
                <input type='text' id='content' value={inputData.content} placeholder='Comment...' onChange={inputHandler}  />
             
                <button type='submit'>
                  <span className='com-send'>Send</span> 
                  <span className='com-icon'><IoIosSend /></span>
                </button>   
              </div>                           
            </form> 

            ) : (

            <form onSubmit={handleComment} className='com-form-container'>
              <label htmlFor='text'/>
              <div className='com-form-controller'> 
                <img src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} alt={user.name}/>    
                  
                <input type='text' id='content' value={inputData.content} placeholder='To comment on the post, Please log in!' onChange={inputHandler} disabled={!user} />
             
                <button type='submit'>
                  <span className='com-send' disabled={!user}>Send</span> 
                  <span className='com-icon' disabled={!user}><IoIosSend /></span>
                </button>       
              </div>                           
            </form>  
            )
          }  
        </>
      ) : (
        <p>Loading...</p>
      )}  
    </main>
  )
}
export default Comment;